var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Export',{attrs:{"formats":[
          { value: 'png', label: _vm.$t('as PNG image') },
      ],"disabled":_vm.disabled},on:{"export":function($event){return _vm.$emit('export', arguments[0])}}})
}
var staticRenderFns = []

export { render, staticRenderFns }